'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'feather-pointed';
var width = 512;
var height = 512;
var aliases = ["feather-alt"];
var unicode = 'f56b';
var svgPathData = ['M86.8 352.3c3.7 13.8 12.1 26.3 23.2 38.3L339.3 161.4c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-51.3 51.2 154 0c3.3-8.7 6.4-17.4 9.3-26.1 20.2-61.2 30.1-121.7 33.4-162.4 .4-5-1.5-10.1-5.4-14s-9.1-5.8-14-5.4c-40.8 3.3-101.2 13.2-162.4 33.4-61.4 20.2-122.3 50.4-165.4 93.5-75.2 75.2-75.4 159.4-61.9 209.3zm34.6 49.7c12.1 11.1 24.6 19.5 38.4 23.3 49.9 13.5 134.2 13.3 209.3-61.9 8.5-8.5 16.4-17.6 23.9-27.3l-205.6 0-66 65.9zm82-81.9l201.2 0c16.7-24.5 30.7-51.7 42.4-80l-163.6 0-80 80z', 'M475.3 .1c9.9-.8 19.6 3 26.6 10s10.8 16.7 10 26.6l-1.6 16.6c-9.7 87.2-44.5 235.8-129.9 321.3l-7.5 7.3c-73.1 68.1-153.7 72.6-206.7 61.3l-10.6-2.5c-17.4-4.7-32.3-15.1-45.6-27.4L13.7 509.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l96.4-96.4c-10.5-11.3-19.7-23.8-25.1-38.1l-2.4-7.3C57.2 304 57.3 217.3 130.1 139.2l7.3-7.5C222.8 46.2 371.5 11.4 458.7 1.7L475.3 .1zM187.3 336l-66 65.9c12.1 11.1 24.6 19.5 38.4 23.3 49.9 13.5 134.2 13.3 209.3-61.9 8.5-8.5 16.4-17.6 23.9-27.3l-205.6 0zM476.5 16.1c-40.8 3.3-101.2 13.2-162.4 33.4-61.4 20.2-122.3 50.4-165.4 93.5-75.2 75.2-75.4 159.4-61.9 209.3 3.7 13.8 12.1 26.3 23.2 38.3L339.3 161.4c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-51.3 51.2 154 0c3.3-8.7 6.4-17.4 9.3-26.1 20.2-61.2 30.1-121.7 33.4-162.4 .4-5-1.5-10.1-5.4-14s-9.1-5.8-14-5.4zM283.3 240l-80 80 201.2 0c16.7-24.5 30.7-51.7 42.4-80l-163.6 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFeatherPointed = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;